import actionTypes from './actionTypes';
import type {
  IFetchOptionsErrorPayload,
  IFetchOptionsRequestPayload,
  IFetchOptionsSuccessPayload,
  IOverview,
  IPairDetail,
  IPositionDetail,
  IQuery,
} from './types';

const actions = {
  fetchOptionsRequest: (payload: IFetchOptionsRequestPayload) => ({ type: actionTypes.FETCH_OPTIONS_REQUEST, payload }),
  fetchOptionsSuccess: (payload: IFetchOptionsSuccessPayload) => ({ type: actionTypes.FETCH_OPTIONS_SUCCESS, payload }),
  fetchOptionsError: (payload: IFetchOptionsErrorPayload) => ({ type: actionTypes.FETCH_OPTIONS_ERROR, payload }),

  fetchOverviewRequest: (payload: IQuery) => ({ type: actionTypes.FETCH_OVERVIEW_REQUEST, payload }),
  fetchOverviewSuccess: (payload: IOverview) => ({ type: actionTypes.FETCH_OVERVIEW_SUCCESS, payload }),
  fetchOverviewError: () => ({ type: actionTypes.FETCH_OVERVIEW_ERROR }),

  fetchPositionRequest: (payload: IQuery & { positionId: string }) => ({
    type: actionTypes.FETCH_POSITION_REQUEST,
    payload,
  }),
  fetchPositionSuccess: (payload: IPositionDetail) => ({ type: actionTypes.FETCH_POSITION_SUCCESS, payload }),
  fetchPositionError: () => ({ type: actionTypes.FETCH_POSITION_ERROR }),

  fetchPairRequest: (payload: IQuery & { positionId: string; agencyContractId: string }) => ({
    type: actionTypes.FETCH_PAIR_REQUEST,
    payload,
  }),
  fetchPairSuccess: (payload: IPairDetail) => ({ type: actionTypes.FETCH_PAIR_SUCCESS, payload }),
  fetchPairError: () => ({ type: actionTypes.FETCH_PAIR_ERROR }),

  clearStore: () => ({ type: actionTypes.CLEAR_STORE }),
};

export type FetchOptionsRequestAction = ReturnType<typeof actions.fetchOptionsRequest>;
export type FetchOverviewRequestAction = ReturnType<typeof actions.fetchOverviewRequest>;
export type FetchPositionRequestAction = ReturnType<typeof actions.fetchPositionRequest>;
export type FetchPairRequestAction = ReturnType<typeof actions.fetchPairRequest>;

export default actions;
